<!-- 選択したメニューの確認ダイアログ -->
<!--POST APIを司るなど結構重い処理を抱き込んでいる-->
<template>
  <div>
    <ItemDialog ref="DialogConfirmMenu" imageType="alert">
      <template v-slot:content-area>
        <p style="text-align: center">
          {{ radio }}と引き換えます。<br />
          引き換えてよろしいですか？
        </p>
      </template>
      <template v-slot:button-area>
        <ItemButton label="OK" actionType="btn-primary" @clicked="clickedOk" />
        <ItemButton label="キャンセル" actionType="btn-cancel" @clicked="closeDialog" />
      </template>
    </ItemDialog>

    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref, SetupContext } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";
import bookService from "@/services/book";

import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogConfirmMenu",
  components: {
    DialogLoading: DialogLoading,
  },
  props: {
    radio: {
      type: String,
    },
  },
  setup(props, context) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogLoading = ref(null);
    const DialogConfirmMenu = ref(null);

    const book = store.getters["ticketing/book"];
    const bookGroup = store.getters["ticketing/bookGroup"];
    const masterBook = store.getters["ticketing/masterBook"];
    const masterSheet = store.getters["ticketing/masterSheet"];
    const sheet = store.getters["ticketing/sheet"];
    const frame = store.getters["ticketing/frame"];

    const openDialog = () => {
      DialogConfirmMenu.value.open();
    };

    const closeDialog = () => {
      DialogConfirmMenu.value.close();
    };

    // フレーム有効化POSTを行う前の前準備
    const clickedOk = async () => {
      closeDialog();
      DialogLoading.value.openDialog();

      // is_fixed_frame==trueならそのフレームを指定するのみでいい
      if (masterSheet.is_fixed_frame) {
        validFramesAPI(frame.id);
      } else {
        // そうで無い場合は無制限シートなので
        // 未使用フレームがある場合はそのフレームを指定するのみでいいが
        // 未使用フレームが無い場合はフレームを作成する必要がある

        // this.frameに未使用フレームが指定されているか、空なのかをチェック
        // TheSheetLowerにも同じ記述あり
        var frame_id = null;

        // ストアにあるならそれをAPIリクエストに投げる
        if (frame && frame.id) {
          frame_id = frame.id;
        } else {
          // 空なら未使用フレームを新たに生成
          frame_id = (await API.postFrames(sheet)).id;
        }
        console.log("frame_id :>> ", frame_id);
        validFramesAPI(frame_id);
      }
    };

    // POSTAPI処理を主に実行
    const validFramesAPI = async (frame_id) => {
      try {
        // ブック自体を初めて使う場合はブックをvalidにする処理を挟む
        if (!book.is_valid) {
          await bookService.executeValidBooks(
            bookGroup,
            masterBook.is_multi_validatable
          );
        }

        if (route.query.onetime) {
          // ワンタイムパスのAPI
          await API.putMamoruOnetimepass(frame_id, route, props.radio);
        } else if (route.query.mamoru_auth) {
          // QRのAPI
          await API.putMamoruQR(frame_id, route, props.radio);
        }

        nativeHandlerService.ncUseSheet(
          masterBook.id,
          bookGroup.id,
          book,
          masterBook.start_hour
        );

        // シート使用済みページへ
        await goToSheet();
      } catch (err) {
        console.log("err :>> ", err);
        DialogLoading.value.closeDialog();
        // エラーハンドリング
        context.emit("ErrorHandlingDialog", [err.response.data.error, "open"]);
      }
    };

    // シート使用済みページへ移動
    const goToSheet = () => {
      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: book.id,
          master_sheet_id: sheet.master_sheet_id,
          sheet_id: String(sheet.id),
        },
        query: { language: store.getters["common/lang"] },
      });
    };

    return {
      DialogLoading,
      DialogConfirmMenu,
      openDialog,
      closeDialog,
      clickedOk,
    };
  },
};
</script>
